import * as constants from "@/constants";

export type PlotPlanMappingState = {
  plotPlanId: number;
};

export const plotPlanMapping = (
  state = {
    plotPlanId: 0,
  },
  action
) => {
  switch (action.type) {
    case constants.PLOT_PLAN_MAPPING_SET_PLOT_PLAN_ID: {
      return {
        ...state,
        plotPlanId: action.payload,
      };
    }
    default:
      return state;
  }
};
